import { ItemNode } from '../models/item';

export class ItemListInjectionToken {
    itemList: ItemNode[];

    constructor(_itemList) {
        this.itemList = _itemList;
    }

}
